import { Add, AddCircle, ArrowDownward, ArrowDropDown, ArrowDropUp, Autorenew, Cancel, Check, CheckBox, CheckBoxOutlineBlank, Close, CloudDownloadOutlined, DeleteOutlined, DragIndicator, EditOutlined, Error, Event, ExpandLess, ExpandMore, FilterList, FilterListOff, FirstPage, FormatAlignLeft, FormatAlignCenter, FormatAlignRight, FormatAlignJustify, FormatBold, FormatItalic, FormatListBulleted, FormatListNumbered, FormatStrikethrough, FormatUnderlined, Fullscreen, FullscreenExit, HelpOutline, IndeterminateCheckBox, InfoOutlined, LastPage, LayersOutlined, Link, LinkOff, Logout, Menu, MenuOpen, MoreVert, NavigateBefore, NavigateNext, NotificationsOutlined, NotificationsOffOutlined, OpenInNew, QuestionAnswerOutlined, Replay, Remove, RemoveCircle, SaveOutlined, Search, SellOutlined, SendOutlined, SettingsOutlined, ViewSidebarOutlined, ViewWeekOutlined, Visibility, VisibilityOff, ZoomIn, ZoomOut, ArrowBackIosNew, ArrowForwardIos, } from '@mui/icons-material';
/*
* MUI build in icons: Import-export MUI icons https://fonts.google.com/icons?icon.set=Material+Icons.
* Key must start by 'mui:' to recognize MUI list
*/
export var MUI_ICONS = {
    'mui:Add': Add,
    'mui:AddCircle': AddCircle,
    'mui:ArrowDownward': ArrowDownward,
    'mui:ArrowDropDown': ArrowDropDown,
    'mui:ArrowDropUp': ArrowDropUp,
    'mui:Autorenew': Autorenew,
    'mui:Cancel': Cancel,
    'mui:ArrowBackIosNew': ArrowBackIosNew,
    'mui:ArrowForwardIos': ArrowForwardIos,
    'mui:Check': Check,
    'mui:CheckBox': CheckBox,
    'mui:CheckBoxOutlineBlank': CheckBoxOutlineBlank,
    'mui:Close': Close,
    'mui:CloudDownloadOutlined': CloudDownloadOutlined,
    'mui:DeleteOutlined': DeleteOutlined,
    'mui:DragIndicator': DragIndicator,
    'mui:EditOutlined': EditOutlined,
    'mui:Error': Error,
    'mui:Event': Event,
    'mui:ExpandLess': ExpandLess,
    'mui:ExpandMore': ExpandMore,
    'mui:FilterList': FilterList,
    'mui:FilterListOff': FilterListOff,
    'mui:FirstPage': FirstPage,
    'mui:FormatAlignLeft': FormatAlignLeft,
    'mui:FormatAlignCenter': FormatAlignCenter,
    'mui:FormatAlignRight': FormatAlignRight,
    'mui:FormatAlignJustify': FormatAlignJustify,
    'mui:FormatBold': FormatBold,
    'mui:FormatItalic': FormatItalic,
    'mui:FormatListBulleted': FormatListBulleted,
    'mui:FormatListNumbered': FormatListNumbered,
    'mui:FormatStrikethrough': FormatStrikethrough,
    'mui:FormatUnderlined': FormatUnderlined,
    'mui:Fullscreen': Fullscreen,
    'mui:FullscreenExit': FullscreenExit,
    'mui:HelpOutline': HelpOutline,
    'mui:IndeterminateCheckBox': IndeterminateCheckBox,
    'mui:InfoOutlined': InfoOutlined,
    'mui:LastPage': LastPage,
    'mui:LayersOutlined': LayersOutlined,
    'mui:Link': Link,
    'mui:LinkOff': LinkOff,
    'mui:Logout': Logout,
    'mui:Menu': Menu,
    'mui:MenuOpen': MenuOpen,
    'mui:MoreVert': MoreVert,
    'mui:NavigateBefore': NavigateBefore,
    'mui:NavigateNext': NavigateNext,
    'mui:NotificationsOutlined': NotificationsOutlined,
    'mui:NotificationsOffOutlined': NotificationsOffOutlined,
    'mui:OpenInNew': OpenInNew,
    'mui:QuestionAnswerOutlined': QuestionAnswerOutlined,
    'mui:Replay': Replay,
    'mui:Remove': Remove,
    'mui:RemoveCircle': RemoveCircle,
    'mui:SaveOutlined': SaveOutlined,
    'mui:Search': Search,
    'mui:SellOutlined': SellOutlined,
    'mui:SendOutlined': SendOutlined,
    'mui:SettingsOutlined': SettingsOutlined,
    'mui:ViewSidebarOutlined': ViewSidebarOutlined,
    'mui:ViewWeekOutlined': ViewWeekOutlined,
    'mui:Visibility': Visibility,
    'mui:VisibilityOff': VisibilityOff,
    'mui:ZoomIn': ZoomIn,
    'mui:ZoomOut': ZoomOut,
};
export var OBJECT_TYPES = [
    'data-asset',
    'data-set',
    'data-structure',
    'status',
    'business-term',
    'business-rule',
    'entity',
    'composite-type',
    'attribute-definition',
    'attribute',
    'data-field',
    'technical-data-mapping',
    'custom-property-group',
    'custom-property',
    'data-source',
    'value-type',
    'requirement',
    'business-model-mapping',
    'business-model-diagram',
    'process',
    'process-step',
    'process-mapping',
    'process-diagram',
    'businessTermRelatedValue',
    'user',
];
export var OTHER_ICONS = [
    'dataLineage',
    'dataProfile',
    'businessTermReferencing',
    'businessTermReferenced',
    'connection',
    'accurityLogoFill',
    'filter',
    'merged',
    'role',
    // notification center
    'cancel',
    'success',
    'error',
    'resultPassed2',
];
//# sourceMappingURL=icons.js.map